import ProductPageLayout from "@/components/ProductPageLayout";
import lasirullaverho from "@/assets/lasirullaverho.png?format=webp&w=800";

const BalconyInstallation = () => (
  <ProductPageLayout title="Balcony blinds & roller blinds" metaDescription="Balcony blind and roller blind installation in Central Uusimaa. Professional installation." image={lasirullaverho} partner="osio" path="/en/balcony-installation" alternatePath="/parveke-asennus">
    <p className="text-muted-foreground leading-relaxed">
      Balcony glazing blinds and roller blinds protect your balcony from sunlight and provide privacy. 
      We offer a comprehensive range of motorized and manual models.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Product types</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Balcony blinds – manual and motorized</li>
      <li>✓ Balcony roller blinds – sun protection and privacy</li>
      <li>✓ Solutions for balcony glazing</li>
    </ul>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Professional installation</h2>
    <p className="text-muted-foreground leading-relaxed">
      Mounting requires sturdy structure and professional work. We ensure the correct mounting method 
      and a durable result. We serve Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen and Tuusula.
    </p>
    <p className="text-muted-foreground mt-4">
      Browse the <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osio range</a>.
    </p>
  </ProductPageLayout>
);

export default BalconyInstallation;
